module.exports = __webpack_public_path__ + "img/route.934c0d84.jpg";